import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"


export const generatePreSignedUrl = data => post(url.GENERATE_PRE_SIGNED_URL, data);
export const generatePresignedUrlForAccess = data => post(url.GENERATE_PRE_SIGNED_URL_FOR_ACCESS, data);
export const generatePresignedUrlForProcessContentAccess = data => post(url.GENERATE_PRE_SIGNED_URL_FOR_PROCESS_CONTENT_ACCESS, data);

